import React, { Component } from "react";

import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { reduxForm, Form, Field } from "redux-form";
import { Link } from 'react-router';

import LogoHorizontal from '../../../assets/images/logo-horizontal.png';
import Message from '../../../common/components/message/message';
import Loading from "../../../common/components/ui/loading/loading";
import Button from "../../../common/components/ui/button/button";

import types from '../authTypes';
import { register } from '../authActions';
import { setLoading } from "../../../helpers/redux";
import fields from "./fields";

class Register extends Component {

    onSubmit = (values) => {
        this.props.setLoading(types.AUTH_LOADING, true);
        this.props.register(values, this.props.router);
    }

    renderFields = () => {
        return fields().map((field, index) => (
            <Field key={index} {...field} />
        ))
    }

	render() {
        const { handleSubmit } = this.props;
		return (
            <section className="register">
                <div className="register__box padding-bottom-medium">
                    <div className="register__header-box">
                        <div className="margin-top-medium margin-bottom-medium">
                            <img src={LogoHorizontal} className="register__header-box--img" alt="Logo"/>
                        </div>
                    </div>
                    <Form className="form register__form-box" role='form' onSubmit={handleSubmit(this.onSubmit)} noValidate>
                        <div className="form__body">
                            {this.renderFields()}
                        </div>
                        <div>
                            <Button
                                text='Entrar'
                                type="submit"
                                style={{width: '100%', padding: 5}}
                                rounded
                                radius={10}
                                buttonType='primary'
                            />                            
                        </div>
                    </Form>
                    <div className="register__footer-box margin-top-small">
                        <Link to='/' style={{flex: 1, textAlign: 'center'}}>Voltar a página principal</Link>
                    </div>
                </div>
                
                <Message />
                <Loading
                    isVisible={this.props.loading}
                />
            </section>
        )
	}
}

Register = reduxForm({ form: 'registerForm' })(Register);

const mapStateToProps = (state) => {
    return {
        user: state.auth.user,
        validToken: state.auth.validToken,
        loading: state.auth.loading
    }
}

const mapDispatchToProps = (dispatch) => ({
    ...bindActionCreators({register, setLoading}, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Register);